import { Component, OnInit } from '@angular/core';
import { IMAGES } from 'src/app/constants/imagePath';

@Component({
    selector: 'app-bfsi',
    templateUrl: './bfsi.component.html',
    styleUrls: ['./bfsi.component.scss'],
    standalone: false
})
export class BfsiComponent implements OnInit {
  Images = IMAGES;
  constructor() { }

  ngOnInit() {
    window.scrollTo({ top: 0, behavior: 'auto' });

  }

}
